import { Button, Col, Container, Row } from 'react-bootstrap'
import { Jobs } from 'src/@shared/types/cms/jobs'
import Link from 'next/link'

import JobAccordion from '@atk/components/accordion/JobAccordion/JobAccordion'

import FramerMotion from '@atk/hooks/framerMotion'

import styles from './OpenRoles.module.scss'

export default function OpenRoles({ jobs }: { jobs: Jobs[] }) {
    return (
        <section className={styles.openRolesContainer}>
            <FramerMotion y={100}>
                <Container>
                    <Row>
                        <Col md={6}>
                            <p className="half-title">Careers</p>
                            <h2 className="h1">
                                Open <span className="text-green">roles</span>
                            </h2>
                        </Col>
                        <Col md={6}>
                            <hr className={styles.hrStyle} />
                            <p className="mb-5">
                                We are always looking for outstanding talent. Not seeing the right fit for you here?
                                Feel free to submit an open application and check back frequently for new postings!
                            </p>
                            <Link target="_blank" href="https://apply.workable.com/casperlabs/j/E9C5207739/">
                                <Button variant="secondary">Submit application</Button>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </FramerMotion>
            <JobAccordion items={jobs} />
        </section>
    )
}
